var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTargetMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,23h-4.0506592C41.4440918,13.8741455,34.1258545,6.5559082,25,6.0506592V2h-2v4.0506592 C13.8741455,6.5559082,6.5559082,13.8741455,6.0506592,23H2v2h4.0506592C6.5559082,34.1258545,13.8741455,41.4440918,23,41.9493408 V46h2v-4.0506592C34.1258545,41.4440918,41.4440918,34.1258545,41.9493408,25H46V23z M25,39.9493408V36h-2v3.9493408 C14.9765015,39.449585,8.550415,33.0234375,8.0506592,25H12v-2H8.0506592C8.550415,14.9765625,14.9765015,8.550415,23,8.0506592V12 h2V8.0506592C33.0234985,8.550415,39.449585,14.9765625,39.9493408,23H36v2h3.9493408 C39.449585,33.0234375,33.0234985,39.449585,25,39.9493408z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTargetMedium);
export default __webpack_public_path__ + "static/media/map-target--medium.4941b02db531345dbbe32f37881d08f5.svg";
export { ForwardRef as ReactComponent };